import { getFormData, RestClient } from "clients/rest";

export type B090060LocationidoRequest = {
  excelFileData: File;
  idoYmd: string;
  shainCd: string;
  bumonCd: string;
};

//Excel取込処理(ロケーション移動入力)
export const B090060ImportLocationido = (props: B090060LocationidoRequest) => {
  return RestClient.post("b090060/import/locationido", getFormData(props));
};

export type B090060SokobuturyuRequest = {
  excelFileData: File;
  idoYmd: string;
  shainCd: string;
  bumonCd: string;
  harailocationCd: string;
  ukesokoCd: string;
};

//Excel取込処理(倉庫移動入力-物流)
export const B090060ImportSokobuturyu = (props: B090060SokobuturyuRequest) => {
  return RestClient.post("b090060/import/sokobuturyu", getFormData(props));
};

export type B090060SokohonshaRequest = {
  excelFileData: File;
  idoYmd: string;
  shainCd: string;
  bumonCd: string;
  haraisokoCd: string;
  ukesokoCd: string;
};

//Excel取込処理(倉庫移動入力-本社)
export const B090060ImportSokohonsha = (props: B090060SokohonshaRequest) => {
  return RestClient.post("b090060/import/sokohonsha", getFormData(props));
};

export type B090060ZaikochoseiRequest = {
  excelFileData: File;
  choseiYmd: string;
  shainCd: string;
  bumonCd: string;
};

//Excel取込処理(倉庫移動入力-本社)
export const B090060ImportZaikochosei = (props: B090060ZaikochoseiRequest) => {
  return RestClient.post("b090060/import/zaikochosei", getFormData(props));
};
